import { render, staticRenderFns } from "./AssetAccountability.vue?vue&type=template&id=3ec84c02&scoped=true"
import script from "./AssetAccountability.vue?vue&type=script&lang=js"
export * from "./AssetAccountability.vue?vue&type=script&lang=js"
import style0 from "./AssetAccountability.vue?vue&type=style&index=0&id=3ec84c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec84c02",
  null
  
)

export default component.exports